var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioTranscriptionRecording(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AudioTranscriptionRecording"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.33259 10.0086C9.59735 10.0086 10.6183 9.0212 10.6183 7.79805V3.37702C10.6183 2.15387 9.59735 1.1665 8.33259 1.1665C7.06783 1.1665 6.04688 2.15387 6.04688 3.37702V7.79805C6.04688 9.0212 7.06783 10.0086 8.33259 10.0086Z",
    fill: "#45657B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.1429 7.79834C12.1429 9.83201 10.4362 11.4825 8.33333 11.4825C6.23048 11.4825 4.52381 9.83201 4.52381 7.79834H3C3 10.3994 4.98857 12.5362 7.57143 12.8973V15.1667H9.09524V12.8973C11.6781 12.5362 13.6667 10.3994 13.6667 7.79834H12.1429Z",
    fill: "#45657B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioTranscriptionRecording);
export default __webpack_public_path__ + "static/media/AudioTranscriptionRecording.df66c4676ca7e16bcf929c655c10da6d.svg";
export { ForwardRef as ReactComponent };